import { tokenFor } from "../features/auth/fragment.ts";

const opened = { path: location.pathname.replace(/\/$/, "") || "/" };
if (location.hash !== "") history.replaceState(null, "", `${location.pathname}${location.search}`);

export const openedAt = opened.path;
export const openedToken = tokenFor(openedAt);

export function goTo(path: string): void {
  location.assign(path);
}

export function intoClient(client: string, page = "/"): string {
  return `/ir/${encodeURIComponent(client)}?para=${encodeURIComponent(page)}`;
}
